import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const TrophyIcon = ({ title, id, activeId, setActiveId }) => {
  const isActive = activeId === id;

  const handleInteraction = () => {
    setActiveId(isActive ? null : id); // Toggle active state
  };

  return (
    <div className="flex items-center mr-1 mb-1">
      <div
        className={isActive ? `trophyIcon rounded bg-light-3 dark:bg-dark-2 flex flex-col justify-center items-center cursor-pointer` : `trophyIcon rounded-full bg-light-3 dark:bg-dark-2 flex flex-col justify-center items-center cursor-pointer`}
        onClick={handleInteraction}
        // onMouseLeave={() => setActiveId(null)}
      >
        <img
          src={`/assets/icons/${title.logo}.png`}
          title={title.title}
          alt={title.title}
          className="h-4 w-4"
        />
      </div>
      {isActive && (
  title.division_id ? (
    <Link
      to={`/division/${title.division_id}`}
      className="px-1 pr-2 rounded-r bg-light-3 dark:bg-dark-2 py-1 text-xxs xs:text-xs leading-tight text-left font-medium dark:hover:text-dark-5 hover:text-buiha-red ease-in-out duration-200"
    >
      {title.title}
    </Link>
  ) : (
    <p className="px-1 pr-2 rounded-r bg-light-3 dark:bg-dark-2 py-1 text-xxs xs:text-xs leading-tight text-left font-medium">
      {title.title}
    </p>
  )
)}
    </div>
  );
};

export default TrophyIcon;